/**
 * EndNode - Exit point node for workflows
 * Multiple End nodes allowed for different outputs
 */

import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import type { EndNodeData } from '../../../../stores/workflow/types';

interface EndNodeProps {
  data: EndNodeData;
  selected?: boolean;
}

export const EndNode = memo(({ data, selected }: EndNodeProps) => {
  const outputFormat = data.outputFormat || 'text';

  const formatLabels = {
    text: 'Text',
    json: 'JSON',
    markdown: 'Markdown'
  };

  return (
    <div
      className={`
        flex min-w-[120px] flex-col items-center rounded-full border-2 bg-gradient-to-br
        from-red-400 to-red-600 px-6 py-4 shadow-lg transition-all
        ${selected ? 'border-red-300 ring-4 ring-red-200/50' : 'border-red-500'}
      `}
    >
      {/* Input Handle (top) */}
      <Handle type='target' position={Position.Top} className='!h-3 !w-3 !border-2 !border-white !bg-red-400' />

      {/* Icon */}
      <div className='mb-1 text-white'>
        <svg className='h-6 w-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z' />
        </svg>
      </div>

      {/* Label */}
      <div className='text-sm font-bold text-white'>{data.label || 'End'}</div>

      {/* Output Format Badge */}
      {data.isConfigured && <div className='mt-1 rounded-full bg-white/20 px-2 py-0.5 text-xs text-white'>{formatLabels[outputFormat]}</div>}
    </div>
  );
});

EndNode.displayName = 'EndNode';
